import { RouteLocationNormalizedLoaded } from 'vue-router';

export function mfhRamEmbedPropsForExternalConstructionPlansRoute(route: RouteLocationNormalizedLoaded) {
    const id = +route.params.mfhId;
    const planIdRaw = route.query.planId;
    const planId = typeof planIdRaw === 'string' && /^\d+$/.test(planIdRaw) ? planIdRaw : null;
    const pathAndSearch = planId != null ? `/assets/${id}/construction-plans/${planId}` : `/assets/${id}/construction-plans`;
    return {
        persistenceKey: id,
        pathAndSearch,
        title: 'Construction plans (RAM)',
        wrapInCard: true,
    };
}
